export default __webpack_public_path__ + "static/media/srs.479c36f8.png";